// const formApiUrl_demo = "PHPMailer/sendmail_demo.php";
// const formApiUrl_request = "PHPMailer/sendmail_request.php";

// EMAIL VALIDATION REGEXP
const emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// ===============================


document.addEventListener('DOMContentLoaded', function () {

	// форма про демо
	const formDemo = document.getElementById('form-demo');
	if (formDemo) formDemo.addEventListener('submit', (e) => {
		e.preventDefault();
		// sendFormPHPM(formDemo, formApiUrl_demo)
		// sendFormJivo(formDemo)
		sendFormPost(formDemo)
	});

	// форма про отправить заявку
	const formRequest = document.getElementById('form-request');
	if (formRequest) formRequest.addEventListener('submit', (e) => {
		e.preventDefault();
		// sendFormPHPM(formRequest, formApiUrl_request)
		// sendFormJivo(formRequest)
		sendFormPost(formRequest)
	});


	// отправка через POST
	function sendFormPost(targetForm) {

		let error = formValidate(targetForm);

		if (!error) {

			targetForm.classList.add('is-sending');

			const formName = targetForm.querySelector('[name=request-name]')
				? targetForm.querySelector('[name=request-name]').value
				: '';
			const formPhone = targetForm.querySelector('[name=request-phone]')
				? targetForm.querySelector('[name=request-phone]').value
				: '';
			const formEmail = targetForm.querySelector('[type=email]')
				? targetForm.querySelector('[type=email]').value
				: '';
			const formHosting = targetForm.querySelector('[name=request-hosting]')
				? targetForm.querySelector('[name=request-hosting]').value
				: '';
			const formHowmany = targetForm.querySelector('[name=request-howmany]')
				? targetForm.querySelector('[name=request-howmany]').value
				: '';
			const formNews = targetForm.querySelector('.js_form_newscheck').checked
				? true
				: false;
			const formAgree = !targetForm.querySelector('.js_form_agreecheck')
				? false
				: targetForm.querySelector('.js_form_agreecheck').checked
					? true
					: false;


			const formData = {
				'username': formName,
				'phone': formPhone,
				'email': formEmail,
				'hosting': formHosting,
				'howmany': formHowmany,
				'news': formNews,
				'agree': formAgree,
			};

			// console.log(formData);


			let resultMessage = 'Спасибо, ваша заявка отправлена!';

			// sendData(formData, 'https://monito.run/api/v1/forms');
			// sendData(formData, 'https://rstat.kodix.ru/monito/form');

			const currentLoc = window.location.hostname;

			const formUrl = currentLoc === 'monito.run'
				? 'https://console.monito.run/api/site-form'
				: 'https://console.monito.me/api/site-form';

			sendData(formData, formUrl);



			function sendData(data, targetUrl) {
				console.log('Sending data');

				const XHR = new XMLHttpRequest();

				let urlEncodedData = "",
					urlEncodedDataPairs = [],
					name;

				// Turn the data object into an array of URL-encoded key/value pairs.
				for (name in data) {
					urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
				}

				// Combine the pairs into a single string and replace all %-encoded spaces to
				// the '+' character; matches the behavior of browser form submissions.
				urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');

				// Define what happens on successful data submission
				XHR.addEventListener('load', function (event) {
					targetForm.reset();
					targetForm.querySelectorAll('.js_check_kindarequired:not([required])').forEach(field => {
						field.required = true;
						field.closest('.form__field').classList.add('js_fieldcheck')
					});
					for (const element of targetForm.querySelectorAll('.m-filled')) {
						element.classList.remove('m-filled');
					}
					console.log('send form: success');
					targetForm.classList.remove('is-sending');
					addFormResult(targetForm, resultMessage);
				});

				// Define what happens in case of error
				XHR.addEventListener('error', function (event) {
					resultMessage = 'Что-то пошло не так.';
					console.log('send form: fail');
					targetForm.classList.remove('is-sending');
					addFormResultFail(targetForm, resultMessage);
				});

				// Set up our request
				XHR.open('POST', targetUrl);

				// Add the required HTTP header for form data POST requests
				XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

				// Finally, send our data.
				XHR.send(urlEncodedData);

				// console.log(urlEncodedData);
			}

		}
		else {
			// тут пользователю и так подсвечены нужные поля
		}
	}
	// ====================






	function formValidate(form) {
		let error = false;
		const fieldsRequeired = form.querySelectorAll('.js_fieldcheck .form__input, .js_fieldcheck [type=checkbox]');
		if (fieldsRequeired.length > 0) {
			for (const input of fieldsRequeired) {
				if (isInputError(input)) {
					error = true;
				}
			}
		}
		return error;
	}

	function isInputError(input) {
		inputRemoveError(input);
		if (input.getAttribute('type') === 'email') {
			if (!validateEmail(input.value)) {
				inputAddError(input, 'Пожалуйста, введите валидный e-mail');
				return true;
			}
		} else if (input.getAttribute('type') === 'checkbox' && !input.checked) {
			inputAddError(input, 'Пожалуйста, отметьте этот пункт');
			return true;
		} else if (input.value === '') {
			inputAddError(input, 'Пожалуйста, заполните это поле');
			return true;
		} else {
			return false;
		}
	}

	function inputAddError(input, errorMessage) {
		input.closest('.js_fieldcheck').insertAdjacentHTML('beforeend', `<div class="form__field-note 
		form__error">${errorMessage}</div>`);
		input.closest('.js_fieldcheck').classList.add('is-error');
	}

	function inputRemoveError(input) {
		if (input.closest('.js_fieldcheck').classList.contains('is-error')) {
			input.closest('.js_fieldcheck').classList.remove('is-error');
			for (const element of input.closest('.js_fieldcheck').querySelectorAll('.form__error')) {
				element.remove();
			}
		}
	}

	function addFormResult(target, message) {
		// if (document.querySelector('.form__result')) document.querySelector('.form__result').remove();
		// target.insertAdjacentHTML('beforeend', `<div class="form__result">${message}</div>`);
		target.closest('.form').classList.add('m-showresult');
	}
	function addFormResultFail(target, message) {
		if (document.querySelector('.form__result-fail')) document.querySelector('.form__result').remove();
		target.insertAdjacentHTML('beforeend', `<div class="form__result-fail">${message}</div>`);
	}


	// check email
	function validateEmail(email) {
		const re = emailRegexp;
		return re.test(email);
	}

	// ==================================

	// INPUT STATUS
	function checkFill(item) {
		item.value.length
			? item.classList.add('m-filled')
			: item.classList.remove('m-filled');
	}

	document.querySelectorAll('.js_checkfill').forEach(item => {
		checkFill(item)
		item.onfocus = function () {
			item.classList.add('m-focused');
		}
		item.onblur = function () {
			item.classList.remove('m-focused');
			checkFill(item);
			// isInputError(item);
		}
		item.onkeyup = function () {
			checkFill(item);
		}
	});
	// ========================


	// set / remove required to phone / mail fields
	function setRequired(item) {

		const theForm = item.closest('form');
		if (theForm.querySelector('.js_check_kindarequired.m-filled')) {
			theForm.querySelectorAll('.js_check_kindarequired[required]').forEach(field => {
				field.required = false;
				field.closest('.js_fieldcheck').classList.remove('js_fieldcheck')
			});
		}
		else {
			theForm.querySelectorAll('.js_check_kindarequired:not([required])').forEach(field => {
				field.required = true;
				field.closest('.form__field').classList.add('js_fieldcheck')
			});
		}
	}

	document.querySelectorAll('.js_check_kindarequired').forEach(item => {
		item.addEventListener('blur', (e) => {
			setRequired(item);
		});
		item.addEventListener('keyup', (e) => {
			setRequired(item);
		});
	});
	// ========================

	// INPUT CLEAR
	document.querySelectorAll('.js_input_clear').forEach(item => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			const targetInputs = item.parentNode.querySelectorAll('input, textarea');
			targetInputs.forEach(input => {
				input.value = '';
				input.classList.remove('m-filled');
				input.focus();
			});
		});
	});


	// ========================



});

